// import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { useCommon } from '../context/CommonContext';
import { useEffect } from 'react';

const Thankyou = () => {
    // const auth = useAuth(); 
    const navigate = useNavigate();

    const { surveyEndText, homeTest } = useCommon();

    // const handleButtonClick = () => {
    //     // window.location.href = "/";
    //     navigate("/Panelist");
    // };

    useEffect(() => {
        if (homeTest.current) {
            const timer = setTimeout(() => {
                // Full redirect to Wikipedia, replacing current app context
                window.location.replace('https://www.wikipedia.com');
            }, 2000);
            return () => clearTimeout(timer);
           
        } else {
            const timer = setTimeout(() => {
                navigate('/Panelist');
            }, 12000);
            return () => clearTimeout(timer);
        }
    },[])

    // const signOutRedirect = () => {
    //     auth.removeUser()
    //     const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    //     const logoutUri = process.env.REACT_APP_COGNITO_LOGOUT_URI;
    //     const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;
    //     window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
    //   };

    return (
        <div  className="flex flex-col items-center justify-center h-screen bg-gray-100">
            <div
            className="text-4xl text-gray-800 mb-6 text-center font-normal max-w-full"
            dangerouslySetInnerHTML={{ __html:  surveyEndText.current }}
          />
            {/* <div className="flex flex-row space-x-6">
                <button className="px-6 py-2 bg-black text-white text-xl font-semibold rounded-lg shadow hover:bg-gray-800 transition duration-200 mt-8" onClick={handleButtonClick}>New Panelist</button>
                <button className="px-6 py-2 bg-black text-white text-xl font-semibold rounded-lg shadow hover:bg-gray-800 transition duration-200 mt-8" onClick={() => signOutRedirect()}>Sign out</button>
            </div> */}
        </div>
    );
};

export default Thankyou;
